import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query candidateContractualDocumentById($id: MongoID!) {
    cat {
      candidate {
        byId(_id: $id) {
          _id
          nda_signed {
            staffing_agency
            candidate
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type CandidateContractualDocumentById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['candidate']>['byId']>

const useCandidateContractualDocumentById = (id: string): CandidateContractualDocumentById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const candidate = data?.cat?.candidate?.byId ?? undefined
  return candidate
}

export { useCandidateContractualDocumentById, document as candidateContractualDocumentByIdDocument }
